import Plyr from 'plyr';

$(document).ready(function() {
    const player = new Plyr('#player3', {
        fullscreen: { enabled: false }
    });

    player.elements.container.addEventListener('dblclick', (event) => {
        event.stopPropagation();
        event.preventDefault();
    });

    //touch devices
    let lastTap = 0;
    player.elements.container.addEventListener('touchend', (event) => {
        const currentTime = new Date().getTime();
        const tapLength = currentTime - lastTap;

        if (tapLength < 300 && tapLength > 0) {
            event.stopPropagation();
        }

        lastTap = currentTime;
    });

    $('#videoModal3').on('shown.bs.modal', function () {
        player.play();
    });

    $('#videoModal3').on('hidden.bs.modal', function () {
        player.pause();
        player.currentTime = 0; // Optionally rewind to the start
    });
});